import { render, staticRenderFns } from "./DIconEmptyCategory.vue?vue&type=template&id=03272839&scoped=true&"
import script from "./DIconEmptyCategory.vue?vue&type=script&lang=js&"
export * from "./DIconEmptyCategory.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03272839",
  null
  
)

export default component.exports